import GoingUtils from "@/utils/goingUtils";
/**
 * 设置界面所有元素readOnly
 */
import {deepClone, GoingNewUtils} from "xmgoing-utils";
import {executeStartFlowFun} from "@/main-page-base/ctls/simpleFlowCtls/simpleFlowSubmit/server/flowServer";


/**
 * 获取表单id信息
 */
export const getFormId = function () {
  let contentPageCode: any = document.querySelector(".content-by-page-code");
  if(contentPageCode==null){
    contentPageCode=document.querySelector(".xmPageContent");
  }
  if (contentPageCode) {
    const xmFormEl = contentPageCode.querySelector(".xmFormBody");
    if (xmFormEl) {
      return xmFormEl.getAttribute("id");
    }
  }
  if (document.querySelector(".xmPageContent")) {
    const xmFormEl = document.querySelector(".xmPageContent").querySelector(".xmFormBody");
    if (xmFormEl) {
      return xmFormEl.getAttribute("id");
    }
  }
  return null;
}

/**
 * id  如果是业务提交没有id 如果是流程待办提交是需要id的
 * 获取发起流程参数
 * @param viewModel
 * @param formId
 * @param winParams
 */
export const getFlowParams = function ({
                                         id = '',
                                         opinion = '',
                                         conclusion = '',
                                         formObj,
                                         winParams,
                                         extendParams = {}
                                       }) {
  const params = {
    id,
    opinion,
    conclusion,
    variables: unref(formObj),
    tableCode: unref(winParams).tableCode,
    ...extendParams
  };
  return params;
}
/**
 *  获取流程退回操作的参数
 */
export const getBackFlowParams = function ({viewModel, id = '', backReason}) {
  return {id, opinion: backReason, conclusion: '不同意'};
}

/**
 * 提交数据根据表单id
 * @param formId
 * @param viewModel
 */
export const startFlowByFormId = function ({
                                             formId,
                                             viewModel,
                                             loadingFlag,
                                             emits,
                                             winParams,
                                             clickEvent,
                                             extendParams = {},
                                             backFun
                                           }) {
  viewModel.nodeParams['addFormData'] = viewModel.getFormVuexVal(formId);
  if (viewModel.nodeParams['addFormData'] == null) {
    GoingUtils.showErrorMessage('表单对象不存在，请确认！');
    return void (0);
  }
  viewModel.validateForm(formId, async () => {
      executeStartFlowFun(getFlowParams({viewModel, formId, winParams, extendParams}), (des) => {
        if (des.type === "selectUser") {
          backFun && backFun(des)
        } else {
          GoingUtils.showMessage("提交成功！");
          loadingFlag.value = false;
          nextTick(() => {
            emits('closeWin', {});
            clickEvent('afterSubmit', {res: des});
          })
        }
      })
    }, () => {
      GoingUtils.showErrorMessage('数据校验失败请确认！');
    }
  )
}

export function setFormObjWinParams(blocks, winParams) {
  unref(blocks).forEach((itemObj) => {
    if (itemObj.componentKey === 'xmForm') {
      if (itemObj && itemObj.props) {
        itemObj.props.winParams = winParams;
      }
    }
  })
}

function isNew (val: string) {
  return !/^\d+$/.test(val)
}

function isSameComponent (itemDb, itemObj) {
  if (itemDb.columnId&&isNew(itemDb.columnId)) {
    return itemDb.columnId === itemObj.key
  }
  return itemDb.columnName === itemObj.model.key
}

// 跳过处理的组件
const skipComponents = [
  'xmSubTable',
  'xmButton',
  'xmModal',
]

// 容器组件
const wrapComponents = [
  'xmFormGroupPanel'
]

/**
 * 设置所有输入框 不可以编辑
 * @param formObjElList
 * @param blocks
 * @param canEditorAry
 * @param isHiddenEl
 * @param isRequiredEl
 * @param pItemObj
 */
export function setPageAllReadOnly(formObjElList, blocks, canEditorAry = [], isHiddenEl = [],isRequiredEl=[], pItemObj?: any) {
  if (unref(blocks)) {
    unref(blocks).forEach((itemObj) => {
      // 防止某些情况下没有props
      if (!itemObj.props) {
        itemObj.props = {}
      }

      if (itemObj.props.isFormEl) {
        itemObj.props.disabled = true;
        itemObj.props.readOnlyText = true;
      }
      //如果是表单需要特殊处理
      if (itemObj.componentKey === 'xmForm') {
        const formObj = unref(formObjElList).filter((oldItem) => {
          return oldItem.key === itemObj.key
        })[0];
        if (!formObj) {
          if (unref(pItemObj)) {
            unref(formObjElList).push({...itemObj, pItem: deepClone(pItemObj)});
          } else {
            unref(formObjElList).push(deepClone(itemObj));
          }
        }
      }


      const isEditorEl: any = canEditorAry.filter((itemDb: any) => {
        if (itemObj.model) {
          return isSameComponent(itemDb, itemObj)
        }
        return false;
      })[0];
      const isEditorHide = isHiddenEl&&isHiddenEl.filter((itemDb: any) => {
        if (itemObj.model) {
          return isSameComponent(itemDb, itemObj)
        }
        return false;
      })[0];
      const isRequiredElObj: any = isRequiredEl&&Array.isArray(isRequiredEl)&&isRequiredEl.filter((itemDb: any) => {
        if (itemObj.model) {
          return isSameComponent(itemDb, itemObj)
        }
        return false;
      })[0];
      //表示可以编辑
      if (unref(isEditorEl) && unref(isEditorEl).editable) {
        itemObj.props.disabled = false;
        itemObj.props.readOnlyText = false;
      } else {
        // 容器组件不处理
        if (!wrapComponents.includes(itemObj.componentKey)) {
          // xmButton不做禁用
          itemObj.props.disabled = !skipComponents.includes(itemObj.componentKey)
          itemObj.props.readOnlyText = !skipComponents.includes(itemObj.componentKey)
        }
      }
      //表示需要隐藏
      if (unref(isEditorHide)) {
        itemObj.props.show = false;
      } else {
        itemObj.props.show = true;
      }
      //表示必填
      if(unref(isRequiredElObj)){
        itemObj.props.required = true;
      } else {
        itemObj.props.required = false;
      }

      if (itemObj.props.disabled !== true) {
        itemObj.props.initElValFlag = GoingNewUtils.getUUChar(10);
      }
      if (itemObj.componentKey === 'xmForm'||itemObj.componentKey === 'xmFormGroupPanel'||itemObj.componentKey === 'xmDiv') {
        itemObj.props.readOnlyText=false;
        itemObj.props.disabled = false;
      }
      //如果存在子记录 再执行
      if (itemObj.children) {
        if (!skipComponents.includes(itemObj.componentKey)) {
          setPageAllReadOnly(formObjElList, itemObj.children, canEditorAry, isHiddenEl,isRequiredEl, itemObj)
        }
      }
    })
  }
}
